import React from "react";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.h4,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function NoItemsReturned() {
  return (
    <Box
      sx={{
        width: "100%",
        "& > :not(style)": {
          m: 2,
        },
      }}
    >
      <Item>
        <Stack spacing={2}>
          <Stack spacing={2}>
            <Typography>
              <ProductionQuantityLimitsIcon sx={{ fontSize: 180 }} />
            </Typography>
            <Typography>No items in Cart</Typography>{" "}
          </Stack>
        </Stack>
      </Item>
    </Box>
  );
}

export default NoItemsReturned;
